/* The Barber Store — cart drawer, quick add, variant picker, filters, small motion. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const BS = window.BS || {};

  const money = (cents) => {
    const fmt = BS.moneyFormat || '${{amount}}';
    const n = (cents / 100);
    const withDec = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = n.toLocaleString('en-US', { maximumFractionDigits: 0 });
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === 'amount_no_decimals' ? noDec : withDec);
  };

  const toast = (msg) => {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };

  /* ---------- Open / close panels ---------- */
  const open = (id) => {
    const el = document.getElementById(id); if (!el) return;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll');
    const f = el.querySelector('button, a, input'); f && setTimeout(() => f.focus(), 60);
  };
  const close = (el) => {
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .mobile-nav.is-open')) document.body.classList.remove('no-scroll');
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      if (opener.dataset.open === 'cart-drawer' && document.body.classList.contains('template-cart')) return;
      e.preventDefault(); open(opener.dataset.open); return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) close(closer.closest('.drawer, .mobile-nav'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open, .mobile-nav.is-open').forEach(close); });

  /* ---------- Cart ---------- */
  const refreshCart = async (cart) => {
    if (!cart) cart = await (await fetch(`${BS.routes.cart}.js`)).json();
    if (window.bsGifts) { const synced = await window.bsGifts.sync(cart); if (synced) cart = synced; }
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    $$('[data-cart-count-label]').forEach((el) => { el.textContent = `(${cart.item_count})`; });
    const total = $('[data-cart-total]'); if (total) total.textContent = money(cart.total_price);
    const foot = $('[data-cart-foot]'); if (foot) foot.hidden = cart.item_count === 0;
    const res = await fetch(`${BS.routes.root}?section_id=cart-drawer-items`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const inner = doc.querySelector('.shopify-section') || doc.body;
    const body = $('[data-cart-body]'); if (body) body.innerHTML = inner.innerHTML;
    if (window.bsGifts) window.bsGifts.render(cart);
    if (document.body.classList.contains('template-cart')) location.reload();
  };
  window.bsRefreshCart = refreshCart;

  const prepareCheckout = async () => {
    let cart = await (await fetch(BS.routes.cart + '.js')).json();
    if (window.bsGifts) cart = await window.bsGifts.sync(cart) || await (await fetch(BS.routes.cart + '.js')).json();
    if (cart.items.some(item => item.properties && item.properties._bs_gift && item.final_line_price > 0)) throw new Error('Please review your cart before checkout: a gift is not free.');
    return cart;
  };

  const addToCart = async (formData, btn) => {
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(`${BS.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      await refreshCart();
      open('cart-drawer');
    } catch (err) { toast(err.message); }
    finally { btn && btn.classList.remove('is-loading'); }
  };

  document.addEventListener('submit', async (e) => {
    const f = e.target;
    if (f.querySelector('button[name=checkout]')) {
      e.preventDefault();
      const button = f.querySelector('button[name=checkout]');
      button.disabled = true;
      try {
        const data = new FormData(f);
        if (data.has('note')) await fetch(BS.routes.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: data.get('note') }) });
        await prepareCheckout();
        location.href = BS.routes.root + 'checkout';
      } catch (error) { toast(error.message); button.disabled = false; }
      return;
    }
    if (f.matches('[data-quick-add], [data-product-form]')) {
      e.preventDefault();
      addToCart(new FormData(f), f.querySelector('[type=submit]'));
    }
  });

  const changeLine = async (key, quantity) => {
    const res = await fetch(`${BS.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }) });
    const cart = await res.json();
    if (!res.ok) { toast(cart.description || 'Could not update cart'); return; }
    refreshCart(cart);
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]');
    if (b) { b.disabled = true; changeLine(b.dataset.lineChange, parseInt(b.dataset.qty, 10)); }
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line-input]');
    if (i) changeLine(i.dataset.lineInput, parseInt(i.value, 10) || 0);
  });

  /* ---------- Kit bundles: add every item, then open the cart ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-kit-add]'); if (!b) return;
    const items = b.dataset.kitAdd.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
    b.classList.add('is-loading');
    try {
      const res = await fetch(`${BS.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!res.ok) { const d = await res.json(); throw new Error(d.description || 'Could not add the kit'); }
      await refreshCart(); open('cart-drawer');
    } catch (err) { toast(err.message); } finally { b.classList.remove('is-loading'); }
  });

  /* ---------- Header shadow ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Product page ---------- */
  const pdp = $('[data-product]');
  if (pdp) {
    const product = JSON.parse($('[data-product-json]').textContent);
    const form = $('[data-product-form]', pdp);
    const idInput = $('[data-variant-id]', pdp);
    const addBtn = $('[data-add-button]', pdp);
    const priceEl = $('[data-price]', pdp);
    const stockEl = $('[data-stock]', pdp);
    const mainImg = $('[data-main-image]', pdp);
    const stickyBtn = $('[data-sticky-add]');
    const stickyPrice = $('[data-sticky-price]');

    const setImage = (src) => {
      if (!mainImg || !src) return;
      mainImg.classList.add('is-swapping');
      setTimeout(() => { mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.onload = () => mainImg.classList.remove('is-swapping'); setTimeout(() => mainImg.classList.remove('is-swapping'), 400); }, 180);
    };
    // Hover zoom on the main photo (desktop)
    const gm = $('.gallery__main', pdp);
    if (gm && window.matchMedia('(hover: hover)').matches) {
      gm.addEventListener('mousemove', (e) => { const r = gm.getBoundingClientRect(); gm.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); gm.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); });
      gm.addEventListener('mouseenter', () => gm.classList.add('is-zoom'));
      gm.addEventListener('mouseleave', () => gm.classList.remove('is-zoom'));
    }
    $$('[data-thumb]', pdp).forEach((t) => t.addEventListener('click', () => {
      setImage(t.dataset.thumb);
      $$('[data-thumb]', pdp).forEach((x) => x.setAttribute('aria-current', x === t ? 'true' : 'false'));
    }));

    const selected = () => $$('fieldset.option', pdp).map((fs) => ($('input:checked', fs) || {}).value);
    const markUnavailable = () => {
      const sel = selected();
      $$('.option__values input', pdp).forEach((input) => {
        const idx = +input.dataset.optionIndex;
        const trial = sel.slice(); trial[idx] = input.value;
        const ok = product.variants.some((v) => v.available && v.options.every((o, i) => o === trial[i]));
        input.classList.toggle('is-unavailable', !ok);
      });
    };
    const update = () => {
      const sel = selected();
      const v = product.variants.find((x) => x.options.every((o, i) => o === sel[i]));
      sel.forEach((val, i) => { const l = $(`[data-option-label="${i}"]`, pdp); if (l) l.textContent = val; });
      markUnavailable();
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; if (window.bsCta) window.bsCta(addBtn); return; }
      idInput.value = v.id;
      let displayCompare = v.compare_at_price;
      const realPercent = displayCompare > v.price ? (displayCompare - v.price) * 100 / displayCompare : 0;
      const sample = pdp.dataset.sampleDiscountEnabled === 'true' && v.price > 0 && realPercent < 10;
      const samplePercent = (product.id % 3 + 1) * 10;
      if (sample) displayCompare = Math.ceil(v.price * 100 / (100 - samplePercent));
      const save = displayCompare > v.price ? `<s>${money(displayCompare)}</s><span class="save"></span>` : '';
      priceEl.innerHTML = `<span>${money(v.price)}</span>${save}`;
      const savingLabel = $('.save', priceEl);
      const badge = $('[data-badge]', pdp);
      if (savingLabel) {
        savingLabel.textContent = `Save ${money(displayCompare - v.price).replace(/\.00$/, '')}`;
        if (sample) $('s', priceEl).setAttribute('aria-label', pdp.dataset.sampleReferenceLabel);
      }
      const sampleNote = $('[data-sample-discount-note]', pdp);
      if (sampleNote) sampleNote.hidden = !sample;
      const sampleProperties = {
        discount: pdp.dataset.sampleDiscountLabel.replace('__PERCENT__', samplePercent),
        reference: money(displayCompare || 0),
        percent: String(samplePercent),
        compare: String(displayCompare || 0)
      };
      $('[data-sample-property]', form).forEach(input => {
        input.disabled = !sample;
        input.value = sampleProperties[input.dataset.sampleProperty];
      });
      if (badge) {
        badge.hidden = !(displayCompare > v.price);
        badge.textContent = sample ? pdp.dataset.sampleDiscountLabel.replace('__PERCENT__', samplePercent) : 'Sale';
      }
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; if (payNow) payNow.disabled = !v.available; if (window.bsCta) window.bsCta(addBtn);
      if (stickyBtn) stickyBtn.disabled = !v.available; const sp = $('[data-sticky-pay]'); if (sp) sp.disabled = !v.available;
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stockEl) { stockEl.textContent = v.available ? 'In stock, ready to ship' : 'Sold out'; stockEl.classList.toggle('is-out', !v.available); }
      // limited stock line: "Only N left in stock" when 1-9 are left
      const inv = (() => { try { return JSON.parse(($('[data-inventory]', pdp) || {}).textContent || '{}'); } catch (e) { return {}; } })();
      const low = $('[data-lowstock]', pdp), q = inv[v.id];
      if (low) {
        const show = v.available && q != null && q > 0 && q <= 9;
        low.classList.toggle('is-hidden', !show); if (stockEl && v.available) stockEl.classList.toggle('is-hidden', show);
        if (show) { $('[data-lowstock-text]', low).textContent = `Only ${q} left in stock`; $('[data-lowstock-bar]', low).style.width = (q * 10) + '%'; }
      }
      if (v.featured_media && v.featured_media.preview_image) setImage(v.featured_media.preview_image.src);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('.option__values input', pdp).forEach((i) => i.addEventListener('change', update));
    if ($$('fieldset.option', pdp).length) markUnavailable();

    // Pay now: add this item, then go straight to checkout.
    const payNow = $('[data-pay-now]', pdp);
    if (payNow) payNow.addEventListener('click', async () => {
      payNow.classList.add('is-loading');
      try {
        const res = await fetch(`${BS.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!res.ok) { const d = await res.json(); throw new Error(d.description || 'Could not add to cart'); }
        await prepareCheckout();
        location.href = BS.routes.root + 'checkout';
      } catch (err) { payNow.classList.remove('is-loading'); toast(err.message); }
    });

    $$('[data-qty-step]', pdp).forEach((b) => b.addEventListener('click', () => {
      const q = $('input[name=quantity]', pdp); q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
    }));

    // Delivery estimate: today + N business days, shown as a date range.
    const del = $('[data-delivery]', pdp);
    if (del && BS.shipDays) {
      const [a, b] = String(BS.shipDays).split('-').map((n) => parseInt(n, 10));
      const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; };
      const f = (d) => d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
      if (a && b) del.textContent = `${f(addBiz(new Date(), a))} – ${f(addBiz(new Date(), b))}`;
    }

    // Buy bar fixed to the bottom of the screen at all times (owner, 2026-10-29).
    const sticky = $('[data-sticky-atc]');
    if (sticky) {
      sticky.classList.add('is-visible'); document.body.classList.add('has-buybar');
      stickyBtn.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
      const stickyPay = $('[data-sticky-pay]');
      if (stickyPay && payNow) stickyPay.addEventListener('click', () => payNow.click());
    }

    // Recommendations
    const rec = $('[data-recommendations]');
    if (rec) fetch(rec.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const s = doc.querySelector('.shopify-section'); if (s && s.innerHTML.trim()) rec.innerHTML = s.innerHTML;
    }).catch(() => {});
  }

  /* ---------- Collection filters ---------- */
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    const go = () => {
      const params = new URLSearchParams(new FormData(filterForm));
      [...params.keys()].forEach((k) => { if (!params.get(k)) params.delete(k); });
      location.search = params.toString();
    };
    filterForm.addEventListener('submit', (e) => { e.preventDefault(); go(); });
    if (window.matchMedia('(min-width: 901px)').matches) filterForm.addEventListener('change', (e) => { if (e.target.type === 'checkbox') go(); });
    const sort = $('[data-sort-select]');
    sort && sort.addEventListener('change', () => { $('[data-sort-mirror]', filterForm).value = sort.value; go(); });
    const ot = $('[data-filters-open]'), ct = $('[data-filters-close]');
    ot && ot.addEventListener('click', () => { filterForm.classList.add('is-open'); document.body.classList.add('no-scroll'); });
    ct && ct.addEventListener('click', () => { filterForm.classList.remove('is-open'); document.body.classList.remove('no-scroll'); });
  }

  /* ---------- Motion: reveal, image fade, marquee, cart bump ---------- */
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!calm) {
    document.documentElement.classList.add('motion');
    // Images fade in once loaded
    const fadeImg = (img) => {
      if (img.closest('.hero') || img.classList.contains('fade')) return;
      img.classList.add('fade');
      if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
      else { img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true }); img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true }); }
    };
    $$('main img').forEach(fadeImg);
    // Reveal sections and grid items with a soft stagger
    const targets = $$('.section-head, .cat, .card, .split__card, .brands a, .trust__item, .rev, .newsletter, .pdp__info > *, .accordion');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px' });
      const groups = new Map();
      targets.forEach((el) => { const k = el.parentElement; const n = groups.get(k) || 0; groups.set(k, n + 1); el.style.setProperty('--d', `${Math.min(n, 7) * 70}ms`); el.classList.add('rv'); io.observe(el); });
    }
    // Announcement marquee (duplicate the messages so the loop is seamless)
    const track = $('.announcement__track');
    if (track && track.children.length > 1 && window.innerWidth > 820) { track.innerHTML += track.innerHTML; track.classList.add('is-marquee'); }
    // Cart count bumps when items are added
    const cc = $$('[data-cart-count]');
    new MutationObserver(() => cc.forEach((c) => { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); setTimeout(() => c.classList.remove('bump'), 400); })).observe(cc[0] || document.createElement('i'), { childList: true, characterData: true, subtree: true });
  }
})();
